"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MediaProvider = void 0;

var _react = require("react");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Context = (0, _react.createContext)({});
Context.displayName = 'Media';
var MediaProvider = Context.Provider;
exports.MediaProvider = MediaProvider;

var formatQuery = function formatQuery(query) {
  return query.replace(/^@media( ?)/m, '');
};

var getQuery = function getQuery(queryOrDevice, media) {
  if (typeof media === 'undefined') {
    return queryOrDevice;
  }

  var device = media.devices[queryOrDevice];

  if (device) {
    return media.only(queryOrDevice);
  }

  return queryOrDevice;
};

var useMedia = function useMedia(queryOrDevice) {
  var _useContext = (0, _react.useContext)(Context),
      media = _useContext.media;

  var query = formatQuery(getQuery(queryOrDevice, media));
  var supportMatchMedia = typeof window !== 'undefined';

  var _useState = (0, _react.useState)(function () {
    if (supportMatchMedia) {
      return window.matchMedia(query).matches;
    }

    return undefined;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      match = _useState2[0],
      setMatch = _useState2[1];

  (0, _react.useEffect)(function () {
    var active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    var queryList = window.matchMedia(query);

    var updateMatch = function updateMatch() {
      if (active) {
        var _match = queryList.matches;
        setMatch(_match);
      }
    };

    updateMatch();
    queryList.addListener(updateMatch);
    return function () {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, supportMatchMedia]);
  return match;
};

var _default = useMedia;
exports["default"] = _default;